<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-2" lang="en-GB"><a id="_idTextAnchor002"></a>DNA</h1>
<p class="Verse-first" lang="en-GB">The memory is in our DNA.</p>
<p class="Verse-main" lang="en-GB">We can try to slay it</p>
<p class="Verse-main" lang="en-GB">But we have to obey it.</p>
<p class="Verse-main" lang="en-GB">Catch it.</p>
<p class="Verse-main" lang="en-GB">But it latches on to us.</p>
<p class="Verse-main" lang="en-GB">Be careful of the memories you keep.</p>
<p class="Verse-main" lang="en-GB">You cannot sleep?</p>
<p class="Verse-main" lang="en-GB">The memories abate you, it will become</p>
<p class="Verse-main" lang="en-GB">your trait.</p>
<p class="Verse-new" lang="en-GB">You kiss a girl,</p>
<p class="Verse-main" lang="en-GB">That tattoo,</p>
<p class="Verse-main" lang="en-GB">And it penetrates your flesh as we all may</p>
<p class="Verse-main" lang="en-GB">try to forget.</p>
<p class="Verse-main" lang="en-GB">Your DNA, your Grandma, Grandpa’s</p>
<p class="Verse-main" lang="en-GB">DNA is just a memory like the girl</p>
<p class="Verse-main" lang="en-GB">Who couldn’t get away</p>
<p class="Verse-new" lang="en-GB">A cry for help?</p>
<p class="Verse-main" lang="en-GB">Your DNA wants to yelp.</p>
<p class="Verse-main" lang="en-GB">Sap water, (she was someone’s daughter)</p>
<p class="Verse-main" lang="en-GB">You wanted to fight for her right.</p>
<p class="Verse-main" lang="en-GB">You wanted to be her gallant knight.</p>
<p class="Verse-main" lang="en-GB">Her DNA took flight,</p>
<p class="Verse-main" lang="en-GB">She was out of sight.</p>
<p class="Verse-main" lang="en-GB">Her DNA.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398432048_EPUB6.vue?ff5a9404